// extracted by mini-css-extract-plugin
module.exports = {"formAddButton":"ContactFormAccounts_formAddButton__3KLlz","title":"ContactFormAccounts_title__3wc0x","message_block":"ContactFormAccounts_message_block__2YoQG"};